import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";

export const Banner = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(10px); 
    color: white;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    text-align: center;
    z-index: 9999;

    @media (min-width: 768px) {
        flex-direction: row;
        justify-content: center;
    }
`;

export const Button = styled.button`
  color: white;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  border: 2px solid hsla(93, 19%, 58%, 1.00);
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.3s, border-color 0.3s;
  background-color: hsla(93, 19%, 58%, 1.00);

    &:hover {
        background-color: hsla(93, 30%, 67%, 1.00);
        border-color: hsla(93, 30%, 67%, 1.00);
    }
`;

export const PolicyLink = styled(RouterLink)`
    color: #93a981;
    transition: color 0.3s;

        &:hover {
        color: hsla(93, 30%, 67%, 1.00);
    }
`;